<template>
  <div class="chat-messages-block" :data_pack="pack.packNumber" :data_number="index + 1" :class="[
    checkLastMessage(pack, item),
    fixedMessage && fixedMessage.id == item.id ? 'message_pined' : '',
  ]" :style="
  getFirstNotRead(item)
    ? 'padding-top: 80px'
    : '' || checkPreviousId(item, pack, index)
      ? ''
      : 'margin-top: 8px;'
">
    <div ref="chatBanner" v-if="getFirstNotRead(item)" class="chat-messages-banner">
      Непрочитанные сообщения
    </div>
    <div class="chat-messages-block-item" @mouseover="mouseOver(item)" @mouseleave="mouseLeave(item)">
      <div :class="
        item.adminPanelUserWriter
          ? 'chat-messages-block-bank-icon'
          : 'chat-messages-block-icon'
      ">
        <div @click="$emit('openDialogFixed', item)" v-if="item.adminPanelUserWriter && item.status == 'not_blocked'"
          class="mb-2 mt-2">
          <template v-if="!item.isHidden">
            <v-icon v-if="fixedMessage && fixedMessage.id == item.id" color="var(--app-dark-blue-1)">mdi-pin</v-icon>
            <v-icon v-else>mdi-pin</v-icon>
          </template>
        </div>
        <div v-else></div>

        <div class="mb-1 d-flex align-end">
          <template v-if="checkNextId(item, pack, index)">
            <img v-if="item.userWriter && item.userWriter.photo" :src="item.userWriter.photo"
              @click="$emit('openDialogBlockUser', item)" :class="getStyleBorderPosition(item, true)"
              :style="item.status == 'deleted_by_user' ? 'opacity: 0.4' : ''" />

            <img v-else-if="
              item.adminPanelUserWriter && !item.adminPanelUserWriter.photo
            " :style="item.status != 'not_blocked' ? 'opacity: 0.4' : ''"
              src="../../../../src/assets/logoChatBank.png" />

            <img v-else-if="
              item.adminPanelUserWriter && item.adminPanelUserWriter.photo
            " :style="item.status != 'not_blocked' ? 'opacity: 0.4' : ''" :src="item.adminPanelUserWriter.photo" />

            <div v-else-if="item.userWriter && !item.userWriter.photo" class="chat-messages-block-not-img"
              @click="$emit('openDialogBlockUser', item)" :class="getStyleBorderPosition(item, true)"
              :style="item.status == 'deleted_by_user' ? 'opacity: 0.4' : ''">
              {{ getFirstLetter(item.userWriter) }}
            </div>
            <v-icon v-if="item.userWriter && item.userWriter.isBlocked" color="var(--app-red-1)" size="16"
              class="chat-messages-block-icon-block">mdi-lock</v-icon>
          </template>
          <div v-else style="width: 40px"></div>
        </div>
      </div>

      <div class="chat-messages-block-message" :style="getColorBlockMess(item)" :class="getStyleBorderPosition(item)">
        <div class="block-message-first">
          <div class="block-message-first-name" v-if="checkPreviousId(item, pack, index)"
            :style="item.adminPanelUserWriter ? 'color: #FFFFFF' : ''">
            <div v-if="!modeAll">
              <div>
                {{
                  item.userWriter
                  ? checkWriterName(item.userWriter)
                  : checkWriterName(item.adminPanelUserWriter)
                }}
              </div>
              <div v-if="
                item.userWriter &&
                (item.userWriter.isBankEmployee ||
                  item.userWriter.isKsaMember)
              " :style="getStyleNamePosition(item.userWriter)">
                {{
                  item.userWriter.position
                  ? item.userWriter.position
                  : item.userWriter.isKsaMember
                    ? "Участник КСА"
                    : !item.userWriter.isKsaMember &&
                      item.userWriter.isBankEmployee
                      ? "Сотрудник ВТБ"
                      : ""
                }}
              </div>
            </div>
            <div v-else>
              <div>
                {{
                  item.userWriter
                  ? checkWriterName(item.userWriter)
                  : checkWriterName(item.adminPanelUserWriter)
                }}
                | <span>{{ item.chatTitle }}</span>
              </div>
              <div v-if="
                item.userWriter &&
                (item.userWriter.isBankEmployee ||
                  item.userWriter.isKsaMember)
              " :style="getStyleNamePosition(item.userWriter)">
                {{
                  item.userWriter.position
                  ? item.userWriter.position
                  : item.userWriter.isKsaMember
                    ? "Участник КСА"
                    : !item.userWriter.isKsaMember &&
                      item.userWriter.isBankEmployee
                      ? "Сотрудник ВТБ"
                      : ""
                }}
              </div>
            </div>
          </div>

          <div v-else></div>

          <div class="block-message-first-text" :style="item.adminPanelUserWriter ? 'color: #FFFFFF' : ''">
            <template v-if="item.replyToMessage">
              <div class="block-message-first-text-answer" :style="
                item.userWriter
                  ? 'border-left: 2px solid #1064DD;'
                  : 'border-left: 2px solid #2AA8E0;'
              ">
                <div class="text-answer-block">
                  <div class="text-answer-user" :style="
                    item.userWriter ? 'color: #1064DD;' : 'color: #2AA8E0;'
                  ">
                    {{
                      item.replyToMessage.userWriter
                      ? checkWriterName(item.replyToMessage.userWriter)
                      : checkWriterName(
                        item.replyToMessage.adminPanelUserWriter
                      )
                    }}
                  </div>
                  <div class="text-answer-image" v-if="
                    findImageMessage(item.replyToMessage.attachments).length >
                    0
                  ">
                    <div class="d-flex" v-for="(images, index) in findImageMessage(
                      item.replyToMessage.attachments
                    )" :key="index">
                      <img @click="$emit('openDialogImg', images.body)" :src="images.body" />
                    </div>
                  </div>
                  <div class="text-answer-transition" v-if="
                    findTransitionMessage(item.replyToMessage.attachments)
                      .length > 0
                  ">
                    <div class="answer-transition-object" v-for="(transition, index) in findTransitionMessage(
                      item.replyToMessage.attachments
                    )" :key="index">
                      <div>
                        <v-icon size="16" :color="
                          item.adminPanelUserWriter ? '#ffffff99' : 'var(--app-dark-blue-1)'
                        ">
                          mdi-arrow-right-top
                        </v-icon>
                      </div>
                      <div class="transition-object-text" :style="
                        item.adminPanelUserWriter ? 'color: #ffffff99' : ''
                      ">
                        {{ JSON.parse(transition.body).buttonName }}
                      </div>
                    </div>
                  </div>
                  <div class="text-answer-text">
                    {{ item.replyToMessage.body }}
                  </div>
                </div>
              </div>
            </template>
            <template v-if="
              item.attachments &&
              findImageMessage(item.attachments).length > 0
            ">
              <div class="d-flex" v-for="(images, index) in findImageMessage(item.attachments)" :key="index">
                <img @click="$emit('openDialogImg', images.body)" :src="images.body" />
              </div>
            </template>

            <div class="block-message-first-text-message" v-if="item.body">
              {{ item.body }}
            </div>
            <div class="block-message-first-transition" v-if="findTransitionMessage(item.attachments).length > 0">
              <div class="transition-object" v-for="(transition, index) in findTransitionMessage(
                item.attachments
              )" :key="index">
                <v-icon size="16" :color="item.adminPanelUserWriter ? '#ffffff99' : 'var(--app-dark-blue-1)'">
                  mdi-arrow-right-top
                </v-icon>
                <div class="transition-object-text" v-if="JSON.parse(transition.body).type == 'url'">
                  <a target="_blank" :href="JSON.parse(transition.body).path"
                    :style="item.adminPanelUserWriter ? 'color: #ffffff99' : ''">
                    {{ JSON.parse(transition.body).buttonName }}
                  </a>
                </div>
                <div class="transition-object-text" v-else :style="item.adminPanelUserWriter ? 'color: #ffffff99' : ''">
                  {{ JSON.parse(transition.body).buttonName }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block-message-second" v-if="!item.adminPanelUserWriter">
          <div class="block-message-second-icon" @click="$emit('blockMessage', item)" v-if="
            item.status != 'blocked_automatically' &&
            item.status != 'deleted_by_user'
          ">
            <v-icon v-if="item.status == 'blocked_by_admin'" color="var(--app-dark-blue-1)" size="31">mdi-lock</v-icon>
            <v-icon v-else size="31">mdi-lock-open</v-icon>
          </div>
          <div class="block-message-second-icon" v-else-if="
            item.status != 'blocked_automatically' &&
            item.status == 'deleted_by_user'
          "></div>

          <img v-else-if="item.status == 'blocked_automatically'" src="../../../../src/assets/lockAuto.svg" />

          <!-- <div class="block-message-second-time">
            {{ item.dateCreated | moment("HH:mm") }}
          </div> -->
          <div class="block-message-second-time">
            <template v-if="item.userWriter && item.status == 'deleted_by_user'">
              удаленно
            </template>

            <template v-else>
              {{ item.dateCreated | moment("HH:mm") }}
            </template>
          </div>
        </div>
        <div v-else class="block-message-second-bank">
          <div class="block-message-second-icon" v-if="
            item.status != 'blocked_automatically' && !modeAll && userRoleEdit
          ">
            <div @click="clickMenu(item)">
              <v-icon color="#ffffff" size="31">mdi-dots-horizontal</v-icon>
            </div>
          </div>
          <img v-else-if="item.status == 'blocked_automatically'" src="../../../../src/assets/lockAuto.svg" />
          <div class="block-message-second-icon" v-else></div>
          <div class="block-message-second-time">
            <template v-if="item.adminPanelUserWriter && item.status != 'not_blocked'">
              скрыто
            </template>

            <template v-else>
              {{ item.dateCreated | moment("HH:mm") }}
            </template>
          </div>
        </div>
      </div>
      <div class="chat-messages-block-answer-show">
        <div class="block-answer-icon" v-if="
          item.answerShow &&
          item.status == 'not_blocked' &&
          menuBank.id != item.id
        ">
          <v-icon size="31" @click="$emit('addAnswer', item)" color="var(--app-dark-blue-1)">mdi-reply</v-icon>
        </div>
        <div v-else style="width: 50px"></div>
      </div>
      <div class="chat-messages-block-menu" v-if="menuBank.id == item.id">
        <div @click="$emit('editMessage', item)">Редактировать</div>
        <div @click="$emit('blockMessage', item), (menuBank = {})">
          <span v-if="item.status != 'not_blocked'"> Восстановить </span>
          <span v-else> Скрыть </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    index: { type: Number },
    pack: {},
    firstNotReadMessage: {},
    modeAll: {},
    userRoleEdit: {},
    showAnswerIcon: {},
    allPacks: {},
    fixedMessage: {},
  },
  data: () => ({
    menuBank: {},
    imageMessage: [],
  }),
  created() { },
  mounted() { },
  methods: {
    findImageMessage(list) {
      const images = list.filter((i) => i.type == "image");
      return images;
    },
    findTransitionMessage(list) {
      const links = list.filter((i) => i.type == "transition");
      return links;
    },
    getStyleNamePosition(item) {
      if (item.isKsaMember) {
        return "color: #00AAFF;  font-weight: 400;";
      } else if (!item.isKsaMember && item.isBankEmployee) {
        return "color: var(--app-dark-blue-1);  font-weight: 400;";
      }
    },
    getStyleBorderPosition(item, icon) {
      if (item.userWriter) {
        if (icon) {
          if (item.userWriter.isKsaMember) {
            return "ksa-employee-icon";
          } else if (
            !item.userWriter.isKsaMember &&
            item.userWriter.isBankEmployee
          ) {
            return "bank-employee-icon";
          }
        } else {
          if (item.userWriter.isKsaMember) {
            return "ksa-employee";
          } else if (
            !item.userWriter.isKsaMember &&
            item.userWriter.isBankEmployee
          ) {
            return "bank-employee";
          }
        }
      }
    },
    checkLastMessage(pack, item) {
      if (
        pack.packNumber == this.allPacks[this.allPacks.length - 1].packNumber
      ) {
        if (item.id == pack.messages[pack.messages.length - 1].id) {
          return "mb-6";
        }
      }
    },
    getFirstNotRead(item) {
      if (!this.firstNotReadMessage && !item.isRead) {
        this.$emit("update:firstNotReadMessage", item.id);
        return true
      }
      if (this.firstNotReadMessage && this.firstNotReadMessage == item.id) {
        return true;
      } else {
        return false;
      }
    },
    mouseOver(item) {
      if (!this.modeAll && this.userRoleEdit) {
        this.showAnswerIcon
          ? (item.answerShow = true)
          : (item.answerShow = false);
      }
    },
    mouseLeave(item) {
      if (!this.modeAll && this.userRoleEdit) {
        item.answerShow = false;
        this.menuBank = {};
      }
    },
    clickMenu(item) {
      if (this.menuBank && this.menuBank.id == item.id) {
        this.menuBank = {};
      } else {
        this.menuBank = Object.assign({}, item);
      }
    },
    checkPreviousId(item, pack, index) {
      let idItem, idPre;
      idItem = item.adminPanelUserWriter
        ? item.adminPanelUserWriter.id
        : item.userWriter?.id;
      if (index > 0) {
        idPre = pack.messages[index - 1].adminPanelUserWriter
          ? pack.messages[index - 1].adminPanelUserWriter.id
          : pack.messages[index - 1].userWriter?.id;
        if (idItem == idPre) {
          return false;
        } else {
          return true;
        }
      } else if (
        index == 0 &&
        this.allPacks[pack.packNumber - 1] &&
        this.allPacks[pack.packNumber - 1].show
      ) {
        const findPack = this.allPacks.find(
          (i) => i.packNumber == pack.packNumber - 1
        );
        if (findPack && findPack.messages.length > 0) {
          idPre = findPack.messages[findPack.messages.length - 1]
            .adminPanelUserWriter
            ? findPack.messages[findPack.messages.length - 1]
              .adminPanelUserWriter.id
            : findPack.messages[findPack.messages.length - 1].userWriter?.id;
          if (idItem == idPre) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    },
    checkNextId(item, pack, index) {
      let idItem, idNext;
      idItem = item.adminPanelUserWriter
        ? item.adminPanelUserWriter.id
        : item.userWriter?.id;
      if (index < pack.messages.length - 1) {
        idNext = pack.messages[index + 1].adminPanelUserWriter
          ? pack.messages[index + 1].adminPanelUserWriter.id
          : pack.messages[index + 1].userWriter?.id;
        if (idItem == idNext) {
          return false;
        } else {
          return true;
        }
      } else if (
        index == pack.messages.length - 1 &&
        this.allPacks[pack.packNumber] &&
        this.allPacks[pack.packNumber].show
      ) {
        const findPack = this.allPacks.find(
          (i) => i.packNumber == pack.packNumber + 1
        );

        if (findPack.messages.length > 0) {
          idNext = findPack.messages[0].adminPanelUserWriter
            ? findPack.messages[0].adminPanelUserWriter.id
            : findPack.messages[0].userWriter?.id;
          if (idItem == idNext) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    getFirstLetter(writer) {
      if (writer.lastName || writer.firstName || writer.middleName) {
        return `${writer.lastName.substring(0, 1)}${writer.firstName.substring(
          0,
          1
        )}`;
      }
    },
    getColorBlockMess(item) {
      if (item.adminPanelUserWriter) {
        if (item.status == "not_blocked") {
          return "background: var(--app-dark-blue-1)";
        } else {
          return "background: var(--app-dark-blue-1); opacity: 0.4";
        }
      }
      if (item.userWriter) {
        if (item.status == "deleted_by_user") {
          return "opacity: 0.4 !important;";
        }
      }
    },
    checkWriterName(writer) {
      if (writer.lastName || writer.firstName || writer.middleName) {
        return `${writer.lastName}  ${writer.firstName}  ${writer.middleName}`;
      } else {
        return writer.name;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.chat-messages-block {
  display: flex;
  padding-left: 24px;
  margin-top: 24px;
  position: relative;

  .chat-messages-banner {
    width: 100%;
    position: absolute;
    top: 12px;
    left: 0px;
    height: 40px;
    background: #e7eaf1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--app-dark-blue-1);
  }

  .chat-messages-block-item {
    width: auto;
    display: flex;

    .chat-messages-block-icon {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      position: relative;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
        cursor: pointer;
      }

      .chat-messages-block-icon-block {
        position: absolute;
        bottom: 0;
        right: 0px;
        z-index: 1;
        background: rgb(255 255 255);
        border-radius: 50%;
        padding: 2px;
      }
    }

    .chat-messages-block-bank-icon {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      position: relative;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
        cursor: pointer;
      }
    }

    .chat-messages-block-not-img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      cursor: pointer;
      background: #e7eaf1;
      color: var(--app-dark-blue-1);
      display: flex;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
    }

    .chat-messages-block-message {
      margin-left: 14px;
      width: 656px;
      padding: 16px 20px 16px 22px;
      background: RGB(18, 50, 116, 0.1);
      border-radius: 8px;
      display: flex;

      .block-message-first {
        width: 547px;

        .block-message-first-name {
          font-size: 16px;
          font-weight: 600;
          color: RGB(18, 50, 116, 0.7);
          margin-bottom: 12px;
          word-break: break-word;
          white-space: pre-wrap;
        }

        .block-message-first-text {
          display: flex;
          flex-direction: column;

          img {
            max-width: 540px;
            height: 152px;
            margin-bottom: 8px;
            object-fit: contain;
          }

          .block-message-first-text-message {
            word-break: break-word;
            white-space: pre-wrap;
          }

          .block-message-first-transition {
            margin-top: 8px;

            .transition-object {
              display: flex;

              .transition-object-text {
                margin-left: 8px;

                a {
                  text-decoration: none;
                }
              }
            }
          }

          .block-message-first-text-answer {
            min-height: 40px;

            display: flex;
            align-items: center;
            margin-bottom: 12px;
            margin-left: 4px;

            .text-answer-block {
              padding-left: 8px;

              .text-answer-user {
                font-size: 14px;
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 545px;
              }

              .text-answer-text {
                font-size: 14px;
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 545px;
              }

              .text-answer-image {
                img {
                  max-width: 300px;
                  height: 56px;
                  object-fit: contain;
                }
              }

              .text-answer-transition {
                margin-bottom: 2px;

                .answer-transition-object {
                  display: flex;
                  align-items: center;

                  .transition-object-text {
                    margin-left: 4px;
                    color: var(--app-dark-blue-1);
                    font-size: 14px;
                    font-weight: 400;
                    margin-top: 4px;
                  }
                }
              }
            }
          }
        }
      }

      .block-message-second {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        margin-left: 12px;
        min-width: 55px;

        .block-message-second-icon {
          cursor: pointer;

          i {
            caret-color: red !important;
          }
        }

        .block-message-second-time {
          font-size: 16px;
          font-weight: 400;
          color: var(--app-dark-blue-1);
          margin-top: 4px;
        }
      }

      .block-message-second-bank {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        margin-left: 12px;
        min-width: 55px;

        .block-message-second-time {
          font-size: 16px;
          font-weight: 400;
          color: #f3f3f3;
        }
      }
    }

    .bank-employee {
      border: 3px solid var(--app-dark-blue-1);
    }

    .ksa-employee {
      border: 3px solid #00aaff;
    }

    .bank-employee-icon {
      border: 2px solid var(--app-dark-blue-1);
    }

    .ksa-employee-icon {
      border: 2px solid #00aaff;
    }

    .chat-messages-block-answer-show {
      margin-left: 16px;
      display: flex;
      justify-content: center;
      align-items: center;

      .block-answer-icon {
        cursor: pointer;
      }
    }

    .chat-messages-block-menu {
      position: absolute;
      left: 760px;
      top: 0px;
      background: #ffffff;
      z-index: 10;
      box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);

      div {
        cursor: pointer;

        padding: 8px 32px 8px 16px;
      }

      div:hover {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }
}
</style>